(() => {
  if (window.__awContactFormLocales) return;
  window.__awContactFormLocales = true;
  document.documentElement.setAttribute('data-aw-contact-locale-script', 'loaded');

  const path = window.location.pathname.toLowerCase();
  if (!path.includes('/pages/contact') && !path.includes('/pages/contatti') && !path.includes('/pages/kontakt')) return;

  const language = (document.documentElement.lang || '').toLowerCase();
  const locale = language.startsWith('it') ? 'it'
    : language.startsWith('pt') ? 'pt'
      : language.startsWith('de') ? 'de'
        : language.startsWith('fr') ? 'fr'
          : language.startsWith('es') ? 'es'
            : language.startsWith('en') ? 'en'
              : '';
  if (!locale) return;

  const emailLabels = {
    en: 'Your email address',
    fr: 'Votre adresse e-mail',
    es: 'Tu correo electrónico',
    it: 'La vostra e-mail',
    pt: 'O seu e-mail',
    de: 'Ihre E-Mail-Adresse'
  };

  const copy = {
    it: {
      intro: '<p><strong>Siamo qui per aiutarvi!</strong></p><ul><li>Inviateci un messaggio al <a href="https://wa.me/34651763094">+34 651 763 094</a> per ricevere una risposta più rapidamente.</li><li>Scriveteci a <a href="mailto:support@aromawax.eu">support@aromawax.eu</a>: vi risponderemo entro 24 ore.</li><li>Utilizzate la chat online nell’angolo in basso a destra del sito per ricevere rapidamente assistenza sulle condizioni di vendita, sui prodotti, sul vostro ordine o su qualsiasi altra domanda.</li><li>Controllate in qualsiasi momento lo stato del vostro ordine accedendo <a href="/it/apps/deluxe/account/login">qui</a> al vostro account.</li></ul><p>Non trovate ciò che vi serve? Compilate il modulo online e vi risponderemo il prima possibile.</p>',
      labels: {
        '91599-name-1': 'Nome',
        '91599-text-8': 'Cognome',
        '91599-text-1': 'Numero dell’ordine (se disponibile)',
        '91599-email-1': 'La vostra e-mail',
        '91599-select-1': 'Motivo della richiesta',
        '91599-textarea-1': 'Come possiamo aiutarvi?'
      },
      options: {
        '': 'Selezionate un’opzione',
        'Order Help': 'Assistenza per un ordine',
        Billing: 'Fatturazione',
        'Shipment change': 'Modifica della spedizione',
        'Product information': 'Informazioni sui prodotti',
        Return: 'Reso',
        'Other reasons': 'Altro'
      },
      file: {
        label: 'Allegati',
        title: 'Scegliete un file o trascinatelo qui',
        hint: 'Formati supportati: PDF, JPG, JPEG, PNG, GIF, SVG',
        button: 'Selezionate un file'
      },
      closing: '<p>Saremo lieti di ricevere il vostro messaggio.</p>',
      submit: 'Inviare',
      successTitle: 'Grazie per averci contattato!',
      successMessage: '<p>Abbiamo ricevuto il vostro messaggio. Il nostro servizio clienti vi risponderà al più presto.</p><p>Vi auguriamo una buona giornata!</p>',
      errors: {
        required: '{{ label }} è obbligatorio',
        invalidEmail: 'L’indirizzo e-mail non è valido',
        otherError: 'Si è verificato un errore. Riprovate.'
      }
    },
    pt: {
      intro: '<p><strong>Estamos aqui para ajudar!</strong></p><ul><li>Envie-nos uma mensagem para <a href="https://wa.me/34651763094">+34 651 763 094</a> para obter uma resposta mais rápida.</li><li>Envie-nos um e-mail para <a href="mailto:support@aromawax.eu">support@aromawax.eu</a> e responderemos no prazo de 24 horas.</li><li>Utilize o nosso chat online no canto inferior direito do site para obter ajuda rápida sobre as condições da loja, os produtos, a sua encomenda ou qualquer outra questão.</li><li>Acompanhe a sua encomenda a qualquer momento iniciando sessão <a href="/pt/apps/deluxe/account/login">aqui</a> na sua conta.</li></ul><p>Não encontrou o que procura? Preencha o formulário online e responderemos o mais rapidamente possível.</p>',
      labels: {
        '91599-name-1': 'Nome',
        '91599-text-8': 'Apelido',
        '91599-text-1': 'Número da encomenda (se aplicável)',
        '91599-email-1': 'O seu e-mail',
        '91599-select-1': 'Motivo do contacto',
        '91599-textarea-1': 'Como podemos ajudar?'
      },
      options: {
        '': 'Selecione uma opção',
        'Order Help': 'Ajuda com encomendas',
        Billing: 'Faturação',
        'Shipment change': 'Alteração de envio',
        'Product information': 'Informações sobre produtos',
        Return: 'Devolução',
        'Other reasons': 'Outros motivos'
      },
      file: {
        label: 'Ficheiros anexos',
        title: 'Escolha um ficheiro ou arraste-o para aqui',
        hint: 'Formatos suportados: PDF, JPG, JPEG, PNG, GIF, SVG',
        button: 'Procurar ficheiro'
      },
      closing: '<p>Esperamos receber a sua mensagem!</p>',
      submit: 'Enviar',
      successTitle: 'Obrigado pelo seu contacto!',
      successMessage: '<p>Recebemos a sua mensagem. O nosso serviço de apoio ao cliente responderá o mais rapidamente possível.</p><p>Tenha um excelente dia!</p>',
      errors: {
        required: '{{ label }} é obrigatório',
        invalidEmail: 'O endereço de e-mail não é válido',
        otherError: 'Ocorreu um erro. Tente novamente.'
      }
    },
    de: {
      intro: '<p><strong>Wir sind für Sie da!</strong></p><ul><li>Schreiben Sie uns unter <a href="https://wa.me/34651763094">+34 651 763 094</a>, um möglichst schnell eine Antwort zu erhalten.</li><li>Senden Sie uns eine E-Mail an <a href="mailto:support@aromawax.eu">support@aromawax.eu</a>. Wir antworten innerhalb von 24 Stunden.</li><li>Nutzen Sie den Online-Chat unten rechts auf unserer Website, wenn Sie schnelle Hilfe zu unseren Geschäftsbedingungen, Produkten, Ihrer Bestellung oder einem anderen Anliegen benötigen.</li><li>Verfolgen Sie Ihre Bestellung jederzeit, indem Sie sich <a href="/de/apps/deluxe/account/login">hier</a> bei Ihrem Konto anmelden.</li></ul><p>Sie finden nicht, was Sie benötigen? Füllen Sie das Online-Formular aus. Wir melden uns so schnell wie möglich bei Ihnen.</p>',
      labels: {
        '91599-name-1': 'Vorname',
        '91599-text-8': 'Nachname',
        '91599-text-1': 'Bestellnummer (falls zutreffend)',
        '91599-email-1': 'Ihre E-Mail-Adresse',
        '91599-select-1': 'Grund der Anfrage',
        '91599-textarea-1': 'Wie können wir Ihnen helfen?'
      },
      options: {
        '': 'Bitte auswählen',
        'Order Help': 'Hilfe zur Bestellung',
        Billing: 'Abrechnung',
        'Shipment change': 'Versandänderung',
        'Product information': 'Produktinformationen',
        Return: 'Rückgabe',
        'Other reasons': 'Anderer Grund'
      },
      file: {
        label: 'Anhänge',
        title: 'Datei auswählen oder hierher ziehen',
        hint: 'Unterstützte Formate: PDF, JPG, JPEG, PNG, GIF, SVG',
        button: 'Datei durchsuchen'
      },
      closing: '<p>Wir freuen uns auf Ihre Nachricht!</p>',
      submit: 'Absenden',
      successTitle: 'Vielen Dank für Ihre Nachricht!',
      successMessage: '<p>Wir haben Ihre Nachricht erhalten. Unser Kundenservice meldet sich so schnell wie möglich bei Ihnen.</p><p>Wir wünschen Ihnen einen schönen Tag!</p>',
      errors: {
        required: '{{ label }} ist erforderlich',
        invalidEmail: 'Die E-Mail-Adresse ist ungültig',
        otherError: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
      }
    }
  }[locale];

  const setText = (element, value) => {
    if (element && element.textContent !== value) element.textContent = value;
  };

  const setHtml = (element, value) => {
    if (element && element.innerHTML !== value) element.innerHTML = value;
  };

  const setLabel = (form, id, value) => {
    const field = form.querySelector(`[id="${id}"]`);
    const control = field && field.closest('.globo-form-control');
    const labels = new Set([
      ...form.querySelectorAll(`label[for="${id}"]`),
      ...(control ? control.querySelectorAll('[data-label]') : [])
    ]);
    labels.forEach((label) => {
      label.setAttribute('data-label', value);
      const content = label.matches('.label-content') ? label : label.querySelector('.label-content');
      if (content) {
        setText(content, value);
        content.setAttribute('data-label', value);
      }
    });
  };

  const updateConfig = () => {
    const config = window.Globo && window.Globo.FormBuilder && window.Globo.FormBuilder.forms && window.Globo.FormBuilder.forms[91599] && window.Globo.FormBuilder.forms[91599]['91599'];
    if (!config) return;
    config.errorMessage = { ...config.errorMessage, ...copy.errors };
    if (config.afterSubmit) {
      config.afterSubmit.title = copy.successTitle;
      config.afterSubmit.message = copy.successMessage;
    }
  };

  const apply = () => {
    const form = document.querySelector('.globo-form-id-91599 .globo-form-app');
    if (!form) return false;

    // Keep the contact number current in the app-provided EN/ES/FR intro.
    const contactIntro = form.querySelector('#paragraph-1');
    if (contactIntro) {
      setHtml(contactIntro, contactIntro.innerHTML
        .replaceAll('+34 614 410 662', '+34 651 763 094')
        .replaceAll('34614410662', '34651763094'));
    }

    setLabel(form, '91599-email-1', emailLabels[locale]);
    if (!copy) {
      if (locale === 'es') setHtml(form.querySelector('#paragraph-2'), '<p>¡Esperamos recibir tu mensaje!</p>');
      document.documentElement.setAttribute('data-aw-contact-locale-applied', locale);
      document.documentElement.removeAttribute('data-aw-contact-locale-error');
      return true;
    }

    updateConfig();

    setHtml(form.querySelector('#paragraph-1'), copy.intro);
    Object.entries(copy.labels).forEach(([id, value]) => setLabel(form, id, value));

    const select = form.querySelector('[id="91599-select-1"]');
    if (select) {
      select.querySelectorAll('option').forEach((option) => {
        if (Object.prototype.hasOwnProperty.call(copy.options, option.value)) setText(option, copy.options[option.value]);
      });
    }

    const fileLabel = form.querySelector('label[for="temp-for-91599-file2-1"]');
    if (fileLabel) {
      fileLabel.setAttribute('data-label', copy.file.label);
      fileLabel.setAttribute('aria-label', copy.file.button);
      const content = fileLabel.querySelector('.label-content');
      if (content) {
        setText(content, copy.file.label);
        content.setAttribute('data-label', copy.file.label);
      }
    }
    setText(form.querySelector('.gfb__dropzone--placeholder--title'), copy.file.title);
    setText(form.querySelector('.gfb__dropzone--placeholder--description'), copy.file.hint);
    setText(form.querySelector('.gfb__dropzone--placeholder--button'), copy.file.button);
    setHtml(form.querySelector('#paragraph-2'), copy.closing);

    const submit = form.querySelector('button.next.submit');
    if (submit) {
      if (submit.textContent.trim() !== copy.submit) {
        const spinner = submit.querySelector('.spinner');
        submit.replaceChildren();
        if (spinner) submit.appendChild(spinner);
        submit.append(document.createTextNode(copy.submit));
      }
      const submitText = `<span class="spinner"></span>${copy.submit}`;
      if (submit.getAttribute('data-submit-text') !== submitText) submit.setAttribute('data-submit-text', submitText);
      if (submit.getAttribute('data-next-text') !== copy.submit) submit.setAttribute('data-next-text', copy.submit);
    }

    const keyLabels = Object.fromEntries(Object.entries(copy.labels).map(([id, value]) => [id.replace('91599-', ''), value]));
    keyLabels['file2-1'] = copy.file.label;
    const hiddenLabels = form.querySelector('input[name="_keyLabel"]');
    if (hiddenLabels) hiddenLabels.value = JSON.stringify(keyLabels);

    document.querySelectorAll('.globo-form-id-91599 .message.success .gfb__content-title').forEach((element) => setText(element, copy.successTitle));
    document.querySelectorAll('.globo-form-id-91599 .message.success .content').forEach((element) => setHtml(element, copy.successMessage));
    document.querySelectorAll('.globo-form-id-91599 .message.error').forEach((element) => element.setAttribute('data-other-error', copy.errors.otherError));
    document.documentElement.setAttribute('data-aw-contact-locale-applied', locale);
    document.documentElement.removeAttribute('data-aw-contact-locale-error');
    return true;
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(() => {
      scheduled = false;
      try {
        apply();
        window.__awContactFormLocalesError = '';
      } catch (error) {
        window.__awContactFormLocalesError = String(error && (error.stack || error.message) || error);
        document.documentElement.setAttribute('data-aw-contact-locale-error', window.__awContactFormLocalesError);
      }
    }, 40);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  [150, 400, 900, 1800, 3500, 7000, 12000].forEach((delay) => window.setTimeout(schedule, delay));
  const stabilizationInterval = window.setInterval(schedule, 1000);
  window.setTimeout(() => window.clearInterval(stabilizationInterval), 30000);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
